import { Collapse } from 'bootstrap';
import { polyfill } from "seamless-scroll-polyfill";

polyfill();

const galleryList = [];
const gallery = document.querySelectorAll('.gridder-gallery');
const align = document.querySelectorAll('.gridder-align');

/* stop iframe video */
var stopVideo = function ( element ) {
    var iframe = element.querySelector( 'iframe');
    var video = element.querySelector( 'video' );
    if ( iframe ) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
    }
    if ( video ) {
        video.pause();
    }
}

for (var i = 0; i < gallery.length; i++) {
    galleryList.push(gallery[i].getAttribute('id'));
}


gallery.forEach((element) => {
    const index = galleryList.indexOf(element.getAttribute('id')); // get index
    const yOffset = -100;

    let prev = document.createElement("button");
    prev.className = "prev";
    prev.innerHTML = '<i class="bi bi-arrow-left"></i>';
    prev.setAttribute('data-bs-toggle', 'collapse');
    prev.setAttribute('data-bs-target', '#' + galleryList[index - 1]);
    element.appendChild(prev);

    let next = document.createElement("button");
    next.className = "next";
    next.innerHTML = '<i class="bi bi-arrow-right"></i>';
    next.setAttribute('data-bs-toggle', 'collapse');
    next.setAttribute('data-bs-target', '#' + galleryList[index + 1]);
    element.appendChild(next);

    let close = document.createElement("button");
    close.className = "close";
    close.innerHTML = '<i class="bi bi-x"></i>';
    close.setAttribute('data-bs-toggle', 'collapse');
    close.setAttribute('data-bs-target', '#' + galleryList[index]);
    element.appendChild(close);


    element.addEventListener('shown.bs.collapse', function () {
        const y = this.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    })

    element.addEventListener('hide.bs.collapse', function () {
        stopVideo(element);
    });

    if (index == 0) {
        prev.disabled = true;
    } else if (index == galleryList.length - 1) {
        next.disabled = true;
    }

});


align.forEach((element) => {
    element.addEventListener('shown.bs.collapse', function () {
        const y = this.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    });
    element.addEventListener('hide.bs.collapse', function () {
        stopVideo(element);
    });
})
